module.exports = __webpack_public_path__ + "static/img/data-collection.1b1a888b.svg";